import script from "./Filters.vue?vue&type=script&setup=true&lang=ts"
export * from "./Filters.vue?vue&type=script&setup=true&lang=ts"

import "./Filters.vue?vue&type=style&index=0&id=16415198&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16415198"]])

export default __exports__